import { FlamingoTypes } from '@mode/shared/contract-common';
import { FlamingoActions, SwitchViewActions } from '@mode/switch-views/contract';
import { createReducer, on } from '@ngrx/store';
import * as fromPlan from './plan.reducer';
import { DatasetActions } from '@mode/dataset/contract';

export const flamingoFeatureKey = 'flamingo';

export interface State {
  planRefs: FlamingoTypes.FlamingoPlanRef; // arbitrary token -> plan id mapping
  completedPlanRefs: FlamingoTypes.FlamingoPlanRef; // Keeps the previous plan ref around until the new plan has completed
  signatures: { [switchViewToken: string]: string };
}

export const initialState: State = {
  planRefs: {},
  completedPlanRefs: {},
  signatures: {},
};

export interface FlamingoRoot {
  [flamingoFeatureKey]: State;
  [fromPlan.planFeatureKey]: fromPlan.State;
}

export const planRefsReducer = createReducer(
  initialState.planRefs,
  on(
    FlamingoActions.executePlan,
    FlamingoActions.executePagePlan,
    FlamingoActions.executeExportPlan,
    (state, action) => ({
      ...state,
      [action.refId]: action.plan.id,
    })
  )
);

export const completedPlanRefsReducer = createReducer(
  initialState.planRefs,
  on(
    FlamingoActions.planSuccess,
    FlamingoActions.pagingSuccess,
    FlamingoActions.exportPlanSuccess,
    (state, action) => ({
      ...state,
      [action.refId]: action.request.id,
    })
  ),
  on(FlamingoActions.planFailed, (state, action) => ({
    ...state,
    [action.refId]: action.planId,
  }))
);

export const signaturesReducer = createReducer(
  initialState.signatures,
  on(SwitchViewActions.loadImportedDatasetSuccess, (state, action) => ({
    ...state,
    [action.dataView.switchView.token]: action.dataView.switchView.flamingoSignature,
  })),
  on(DatasetActions.loadDatasetSuccess, (state, action) => ({
    ...state,
    [action.switchView.token]: action.switchView.flamingoSignature,
  })),
  on(SwitchViewActions.loadSwitchViewSuccess, (state, action) => ({
    ...state,
    [action.switchView.token]: action.switchView.flamingoSignature,
  })),
  on(SwitchViewActions.loadExplorationDataView, (state, action) => ({
    ...state,
    [action.dataView.switchView.token]: action.dataView.switchView.flamingoSignature,
  })),
  on(SwitchViewActions.pollingSwitchViewCompleted, (state, action) => ({
    ...state,
    [action.dataView.switchView.token]: action.dataView.switchView.flamingoSignature,
  })),
  on(
    SwitchViewActions.loadGfDataViews,
    SwitchViewActions.loadEditorViewsSuccess,
    SwitchViewActions.refreshEditorViewsSuccess,
    SwitchViewActions.loadReportViewDataViews,
    (state, action) => ({
      ...state,
      ...action.dataViews.reduce(
        (results, dataView) => ({ ...results, [dataView.switchView.token]: dataView.switchView.flamingoSignature }),
        {}
      ),
    })
  ),
  on(FlamingoActions.refreshSwitchViewSignatureSuccess, (state, action) => ({
    ...state,
    [action.switchViewToken]: action.signature,
  }))
);

export const reducer = {
  planRefs: planRefsReducer,
  completedPlanRefs: completedPlanRefsReducer,
  signatures: signaturesReducer,
};
